import { Web3Provider } from "@ethersproject/providers";
export function getLibrary(provider) {
    var library = new Web3Provider(provider, "any");
    library.pollingInterval = 15000;
    return library;
}
//# sourceMappingURL=getLibrary.js.map